module.exports = __webpack_public_path__ + "static/fonts/f05272f9-83e3-4de6-8423-5d57f730c87b.fd6b6e9.woff";